// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!

// packages
import { index } from 'd3-array';
import { json } from 'd3-fetch';

// local
import { RESULTS_URL } from './constants.js';
import { topojsonToGeoJson } from './utils/geography.js';
import { renderSvelteComponent } from './utils/render.js';
import { createFeed, createRaceFeed, indexByApId } from './stores.js';

// components
import ExpectedVote from './components/ExpectedVote.svelte';
import ResultsList from './components/ResultsList.svelte';
import DataTime from './components/DataTime.svelte';

const crosswalk = index(window.CROSSWALK, indexByApId);

// Write your code!
async function main() {
  // raw feed
  const feed = await createFeed(RESULTS_URL);

  // yes/no recall
  const recallRaceFeed = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-H8953-2022-04-05')
  );

  renderSvelteComponent(
    ExpectedVote,
    /** @type {HTMLElement} */ (document.getElementById('recall-results-eevp')),
    { race: recallRaceFeed }
  );

  // candidate choice
  const candidateRaceFeed = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-H8953-2022-04-05')
  );
  // const candidateRaceCandidateLookup = createCandidateLookup(candidateRaceFeed);
  // const candidateRaceSubunitLookup = createSubunitLookup(candidateRaceFeed);

  renderSvelteComponent(
    ResultsList,
    /** @type {HTMLElement} */ (
      document.getElementById('candidate-results-container')
    ),
    { race: candidateRaceFeed, crosswalk }
  );

  renderSvelteComponent(
    DataTime,
    /** @type {HTMLElement} */ (document.getElementById('testing-container')),
    { race: recallRaceFeed }
  );
}

main().catch(console.error);
